import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnActionConfig } from '@lib/ui/actions';

@Component({
  selector: 'sn-drawer-header-actions',
  templateUrl: './drawer-header-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-drawer-header__actions',
  },
})
export class SnDrawerHeaderActionsComponent {
  @Input()
  public actions: SnActionConfig[];

  @Input()
  public context: any;

  constructor() {}
}
